import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchCustomerComponent } from './search-customer/search-customer.component';
import { PagesComponent } from '../pages.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { SearchBoxComponent } from './search-box/search-box.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { AuthGuard } from 'src/guards/auth.guard';
import { NewCustomerComponent } from './new-customer/new-customer.component';
import { SelectBusinessComponent } from './select-business/select-business.component';




export const routes: Routes = [
  {
    path: '', 
    component: PagesComponent, 
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'search-customer', pathMatch: 'full' },
      { path: 'search-customer', component: SearchCustomerComponent },
      { path: 'new-customer', component: NewCustomerComponent },
      { path: 'select-business', component: SelectBusinessComponent }
    ]
  },
];



@NgModule({
  // declarations: [SearchCustomerComponent, SearchResultComponent], // SearchBoxComponent moved to shared module
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [NewCustomerComponent, SelectBusinessComponent]
  
})
export class CustomersModule { }
